import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Steps } from 'primereact/steps';
import { confirmDialog } from 'primereact/confirmdialog';

import Header from '@components/Header';
import UserForm from '@components/Admins/UserForm';
import PerfilForm from '@components/Admins/PerfilForm';
import CountriesForm from '@components/Admins/CountriesForm';
import JustificationModal from '@components/JustificationModal';

import { editAdmin } from '@actions/admins';
import { sendActionToBitacora  } from '@actions/bitacora';

import { CLEAR_VALUES_ADMIN, SET_VALUES_ADMIN } from '@constants/actionType'

import store from '@store'

class EditAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      maxStep:2,
      loadingPage: true,
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      }
    }
  }

  async componentDidMount() {
    const { history } = this.props
    if (history.location.state?.clearCache) {
      await store.dispatch({
        type: CLEAR_VALUES_ADMIN,
      })
    }
    if (!history.location.state?.correo) return history.push("/admins")
    this.setDetailUser(history.location.state)

    return this.setState({loadingPage: false})
  }

  setDetailUser = async (data) => {
    const { perfiles, paises, admin_paises, ...rest } = data
    const profileSelect = perfiles.map(item => item.id)
    let optionCountriesVisible = []
    if (admin_paises === "SOME") {
      optionCountriesVisible = paises.map(item => item.id)
    }
    paises.map(item => item.id)
    await store.dispatch({
      type: SET_VALUES_ADMIN,
      payload: {
        user: rest,
        profileSelect,
        isAllCountriesVisible: admin_paises === "ALL",
        optionCountriesVisible
      }
    })
    return true
  }

  nexStep = async () => {
    const { step } = this.state
    this.setState({ btnSubmitLoading: true });
    // if (step ===  2) return this.createLayouts()
    this.setState(prevState => ({maxStep: step + 1 > prevState.maxStep ? step + 1 : prevState.maxStep}))
    this.setState(prevState => ({step: prevState.step + 1}))
    this.setState({ btnSubmitLoading: false });
  }

  backStep = () => {
    this.setState({ btnSubmitLoading: true });
    this.setState(prevState => ({step: prevState.step - 1}))
    this.setState({ btnSubmitLoading: false });
  }

  validateOnchangeStep = (e) => {
    const { maxStep } = this.state
    if (e.index > maxStep) return true
    return this.setState({step: e.index}) 
  }

  onHideModal = () => {
    this.setState({
      showModalJustification: {
        isVisible: false,
      },
    });
  };

  onconfirmEditAdmin = () => {
    const { t } = this.props;

    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea hacer este cambio?'),
        label: t('Justificación del cambio'),
        continueAction: ({justification}) => this.onEditAdmin(justification),
      },
    });
  }

  onEditAdmin = async (justification) => {
    const { editAdmin, t, history, sendActionToBitacora, user } = this.props
    this.setState({ btnSubmitLoading: false });
    const response = await editAdmin(justification)
    if (!response.status) {
      this.setState({ btnSubmitLoading: false });
      const dataBitacora = {
        transactionName: 'actAdmin',
        reason: `${user.correo} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      confirmDialog({
        message: t('La operación se ha realizado de manera éxitosa'),
        header: t('Confirmación'),
        icon: 'pi pi-check-circle',
        acceptLabel: t('Continuar'),
        rejectClassName: 'hide-component',
        accept: () => history.push('/admins'),
        onHide: () => history.push('/admins')
      });
      return store.dispatch({
        type: CLEAR_VALUES_ADMIN,
      })
    }
    return this.setState({ btnSubmitLoading: false });
  }

  render () {
    const { t } = this.props
    const { step, btnSubmitLoading, loadingPage, showModalJustification } = this.state
    const steps = [
      { label: t("Usuario"), command: (event) => { this.validateOnchangeStep(event) } },
      { label: t("Perfiles"), command: (event) => { this.validateOnchangeStep(event) } },
      { label: t("Paises"), command: (event) => { this.validateOnchangeStep(event) } }
    ]

    const stepsRender = () => {
      if (step === 0) {
        return (
          <UserForm
            success={this.nexStep}
            btnSubmitLoading={btnSubmitLoading}
            isEdit
          />
        );
      }
      if (step === 1) {
        return (
          <PerfilForm
            success={this.nexStep}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
          />
        );
      }
      if (step === 2) {
        return (
          <CountriesForm
            success={this.onconfirmEditAdmin}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
            isEdit
          />
        );
      }
    }

    if (loadingPage) return true
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t("Datos del Administrador")} linkText={t("Ir al listado")} to="/admins" />
          <div className="card">
            <div className="p-grid p-mb-2">
              <div className="p-col-12 p-my-1">
                <Steps model={steps} activeIndex={step} readOnly={false}/>
              </div>
            </div>

            {stepsRender()}
          </div>
        </div>
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.onHideModal()}
          onContinueAction={showModalJustification.continueAction}
        />
      </div>
    )
  }

}

const mapStateToProps = (state) => ({
  user: state.admins.user,
});

const mapDispatchToProps = {
  editAdmin,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(EditAdmin);
